import React, { FC } from 'react';
import { SkeletonBlock, SkeletonRow, SkeletonStack } from 'src/components/widgets/skeleton';

export const PanelLinesSkeleton: FC<{
    widths?: string[];
    lineHeight?: string;
    gap?: string;
    radius?: string;
}> = ({ widths = ['100%', '80%', '60%'], lineHeight = '16px', gap = '8px', radius = '8px' }) => (
    <SkeletonStack aria-hidden='true' $gap={gap}>
        {widths.map((width, index) => (
            <SkeletonBlock key={index} $width={width} $height={lineHeight} $radius={radius} />
        ))}
    </SkeletonStack>
);

export const PanelTextSkeleton: FC = () => <PanelLinesSkeleton widths={['100%', '70%']} lineHeight='14px' gap='8px' radius='4px' />;

export const PanelFormSkeleton: FC = () => (
    <SkeletonStack aria-hidden='true' $gap='14px'>
        <SkeletonBlock $width='40%' $height='14px' />
        <SkeletonBlock $height='10px' />
        <SkeletonBlock $width='80%' $height='10px' />
        <SkeletonBlock $width='60%' $height='28px' $margin='10px 0 0' />
    </SkeletonStack>
);

export const FullModeEditorSkeleton: FC = () => (
    <SkeletonStack aria-hidden='true' $gap='8px'>
        <SkeletonBlock $width='30%' $height='28px' $radius='8px' />
        <SkeletonBlock $height='16px' $radius='8px' $margin='16px 0 0' />
        <SkeletonBlock $width='80%' $height='16px' $radius='8px' />
        <SkeletonBlock $width='60%' $height='40px' $radius='8px' $margin='16px 0 0' />
        <SkeletonBlock $height='16px' $radius='8px' $margin='16px 0 0' />
        <SkeletonBlock $width='90%' $height='16px' $radius='8px' />
        <SkeletonBlock $width='45%' $height='40px' $radius='8px' $margin='16px 0 0' />
        <SkeletonBlock $height='200px' $radius='8px' $margin='24px 0 0' />
    </SkeletonStack>
);

export const SidePanelHeaderSkeleton: FC = () => (
    <SkeletonRow aria-hidden='true' $gap='14px'>
        <SkeletonBlock $width='56px' $height='56px' $radius='8px' />
        <SkeletonStack $gap='8px' $flex='1'>
            <SkeletonBlock $width='60%' $height='18px' />
            <SkeletonBlock $width='35%' $height='12px' />
        </SkeletonStack>
    </SkeletonRow>
);

export const SidePanelStatusSkeleton: FC = () => (
    <SkeletonRow aria-hidden='true' $gap='8px'>
        <SkeletonBlock $width='80px' $height='22px' $radius='6px' />
        <SkeletonBlock $width='70px' $height='22px' $radius='12px' />
    </SkeletonRow>
);

export const SidePanelSectionSkeleton: FC = () => (
    <SkeletonStack aria-hidden='true' $gap='10px'>
        <SkeletonBlock $width='120px' $height='10px' />
        {['70%', '55%', '40%'].map((width, index) => (
            <SkeletonRow key={index} $gap='10px'>
                <SkeletonBlock $width='8px' $height='8px' $round />
                <SkeletonBlock $width={width} $height='13px' />
            </SkeletonRow>
        ))}
    </SkeletonStack>
);
